const maskSelector = '.loading-mask'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('loading', {
    mounted(el, { value }) {
      el.classList.add('loading-mask__parent')

      const loaderContainer = document.createElement('div')

      loaderContainer.classList.add('loading-mask')
      loaderContainer.classList[value ? 'remove' : 'add']('loading-mask--hide')

      el.append(loaderContainer)

      const loader = document.createElement('div')
      loader.classList.add('vloader')
      loaderContainer.append(loader)

      for (let i = 0; i < 2; i++) {
        const loaderItem = document.createElement('div')
        loaderItem.classList.add('vloader__item')
        loader.append(loaderItem)
      }
    },
    updated(el, { value }) {
      const masks = el.querySelectorAll(maskSelector)
      masks.forEach((mask) => mask.classList[value ? 'remove' : 'add']('loading-mask--hide'))
    },
    unmounted(el) {
      const masks = el.querySelectorAll(maskSelector)

      masks.forEach((mask) => {
        if (mask) {
          const spinners = el.querySelectorAll(maskSelector)

          spinners.forEach((spinner) => spinner.remove())
        }
      })

      if (el.classList.contains('loading-mask__parent')) {
        el.classList.remove('loading-mask__parent')
      }
    }
  })
})
